<template lang="html">
  <ul class="serve-wrapper" :class="{ 'need-margin': needMargin }">
    <serviceItem
      v-for="(service, i) in items"
      :service="service"
      :key="service.id"
      :index="i"
    ></serviceItem>
  </ul>
</template>

<script>
import serviceItem from './item'

export default {
  props: {
    params: {
      type: Object
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    needMargin() {
      return (
        this.$route.name !== 'pay-success' &&
        this.$route.name !== 'pay-fail' &&
        this.$route.name !== 'comment-success'
      )
    }
  },
  components: {
    serviceItem
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.serve-wrapper {
  display: block;
  background: #fff;

  &.need-margin {
    margin-top: rem(90px);
  }
}
</style>
